import {
  LayoutDashboard, Printer, Map, Shield, ScrollText, Users, GraduationCap,
  Package, School, CalendarDays, Truck, MonitorPlay, BookOpen, BookText, Library,
  CalendarClock, UserCog, FlaskConical, SlidersHorizontal, ScanLine,
  Megaphone, ClipboardCheck, Database, Briefcase, FileBarChart, UserSearch,
  Mail, Copy, UsersRound, Settings2, Sparkles, UserCheck, UserCircle,
  Circle, ContactRound,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

/**
 * Mapa de ícones Lucide usados no menu dinâmico.
 * O nome (chave) deve corresponder ao valor da coluna `menu_items.icon` no banco.
 *
 * Ao cadastrar um novo item de menu com um ícone novo, lembre-se de adicionar
 * o componente correspondente aqui — caso contrário, o item será exibido com
 * o ícone padrão (`Circle`).
 */
export const iconRegistry: Record<string, LucideIcon> = {
  // Navegação principal
  LayoutDashboard,
  // Serviços
  Printer, Copy, ScanLine, Package, FlaskConical, Map,
  // Eventos
  Megaphone, CalendarDays, ClipboardCheck, MonitorPlay,
  // Acadêmica
  GraduationCap, BookText, BookOpen, Library, CalendarClock, UsersRound, Settings2, ContactRound,
  UserCog, Sparkles,
  // Gestão
  Briefcase, UserSearch, UserCheck, UserCircle, School, FileBarChart,
  ScrollText, Mail, SlidersHorizontal, Database,
  // Compatibilidade / legado
  Shield, Users, Truck,
};

export const resolverIcone = (nome: string): LucideIcon =>
  iconRegistry[nome] ?? Circle;
